import { render, staticRenderFns } from "./PluginOperate.vue?vue&type=template&id=67f34c5b&scoped=true&"
import script from "./PluginOperate.vue?vue&type=script&lang=js&"
export * from "./PluginOperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f34c5b",
  null
  
)

export default component.exports